import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { appliedDiscountCodeState } from '../recoil/atoms';
import { getCookie } from '../util';

export const useDiscountCodeDetection = (): void => {
  const setAppliedDiscountCode = useSetRecoilState(appliedDiscountCodeState);
  useEffect(() => {
    setAppliedDiscountCode(getCookie('discount_code'));
  }, [setAppliedDiscountCode]);
};
